module.exports = __webpack_public_path__ + "static/media/santa-rita.fc8b3e42.svg";